import { styled } from 'stitches.config'
import { Button as _Button } from 'components/Button'

export const OrderOverviewRoot = styled('div', {
  background: '$tertiary-200',
  padding: '$3 $2',
  borderRadius: '12px',

  '@bp2': {
    padding: '$5 $4',
  },
})

export const Button = styled(_Button, {
  height: '42px',
  marginTop: '$2 !important',
})
